import { OpPlannedCompletionModel } from "./op-planned-completion.model";


export class ScheduleWiseOpCompletionModel {
    schedule: string;
    style: string;
    color: string;
    operationQuantities: OpPlannedCompletionModel[];

    constructor(schedule: string, style: string, color: string, operationQuantities: OpPlannedCompletionModel[]) {
        this.schedule = schedule;
        this.color = color;
        this.style = style;
        this.operationQuantities = operationQuantities;
    }
}